module.exports = __webpack_public_path__ + "assets/media/s8.b1fd78ce.mp3";